<template>
  <div class="verifyError">
      <div class="content_wrapper">
          <h1>{{$t('verifyRejectTitle')}}</h1>
          <p>
              {{$t('verifyRejectContent')}}
          </p>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'

export default {
  name: 'Home',
  components: {
  },
  data(){
    return{
    }
    
  },
    computed: {
        ...mapState(['lang','userInfo'])
    },
    created(){
    },
    methods:{
    }
}
</script>
<style lang="less" scoped>
.verifyError{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    .content_wrapper{
        margin-top: 80px;
        border: 1px solid #f0f0f0;
        h1{
            text-align: center;
            color: #332c2b;
            margin-bottom: 50px;
        }
        p{
            text-align: center;
            font-weight: 600;
            font-size: 20px;
            text-align: left;
            color: #332c2b;
            margin-bottom: 30px;
        }
    }
}
</style>
